import { useFoundItLinksDataContext } from '../../../context/PlpContext';
import { ProductListingPageLink } from '../types';
import { modifyImageUrlQueryParams } from '@JohnLewisPartnership/jl-design-system/utils/imageUrlModifier/imageUrlModifier';

export const useFoundItData = () => {
  const foundItLinks = useFoundItLinksDataContext();
  const mainLinks = foundItLinks?.['Main Links'];

  const filteredFoundItLinks = mainLinks
    ? (mainLinks as ProductListingPageLink[])
        .filter((link: ProductListingPageLink) => link.ImageUrl)
        .map((link) => ({
          ...link,
          ImageUrl: modifyImageUrlQueryParams(link.ImageUrl, { wid: 160 }),
        }))
    : [];

  return {
    foundItLinks: filteredFoundItLinks,
  };
};
